import { Navbar } from "@/components/Navbar";
import { SiteFooter } from "@/components/SiteFooter";
import { useContent, POLICY_DEFAULTS } from "@/lib/content";

export default function Policy({ kind }) {
  const c = useContent("policy", POLICY_DEFAULTS);
  const paragraphs = (c[`${kind}_body`] || "").split(/\n\s*\n/).filter(Boolean);
  return (
    <div className="flex min-h-screen flex-col bg-slate-50 dark:bg-slate-950">
      <Navbar />
      <div className="mx-auto w-full max-w-3xl flex-1 px-4 py-14 sm:px-6" data-testid={`policy-${kind}`}>
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-rose-600">{c[`${kind}_updated`]}</p>
        <h1 className="mt-2 font-display text-4xl font-black tracking-tight text-slate-950 dark:text-slate-50 sm:text-5xl" data-testid={`policy-${kind}-title`}>{c[`${kind}_title`]}</h1>
        <div className="mt-8 space-y-5 text-base leading-relaxed text-slate-700 dark:text-slate-300">
          {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
